import WarningMessage from "./WarningMessage";
export default WarningMessage;
